import { render, staticRenderFns } from "./contentandaction.vue?vue&type=template&id=3799d61b&scoped=true"
import script from "./contentandaction.vue?vue&type=script&lang=js"
export * from "./contentandaction.vue?vue&type=script&lang=js"
import style0 from "./contentandaction.vue?vue&type=style&index=0&id=3799d61b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799d61b",
  null
  
)

export default component.exports